goog.provide("shadow.js.shim.module$$mui$material$Dialog");
goog.provide("module$shadow_js_shim_module$$mui$material$Dialog");
shadow.js.shim.module$$mui$material$Dialog = shadow.js.nativeProvides["@mui/material/Dialog"] = shadow$bridge("@mui/material/Dialog");
module$shadow_js_shim_module$$mui$material$Dialog.default = shadow.js.shim.module$$mui$material$Dialog;
